import getGlobal from './global';
import getGlobalBySource from './global-by-source';
import getGlobals from './globals';

export default {
  getGlobal,
  getGlobalBySource,
  getGlobals,
};
